/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import "./Banner.css";
import { Col, Container, Row } from "react-bootstrap";
import myImg from "../../images/myImg.jpg";
import Typical from "react-typical";
// import ParticleComponent from "../../Particle/ParticleComponent";

const Banner = () => {
  return (
    <div className="banner-area">
      {/* <ParticleComponent /> */}
      <Container>
        <Row className="d-flex align-items-center px-3">
          <Col xs={12} md={6} lg={7}>
            <div className="banner-intro">
              <h5>Hey!</h5>
              <h1>I'm MD Mehedi Hasan.</h1>
              <h3>
                I am a{" "}
                <span>
                  <Typical
                    loop={Infinity}
                    wrapper="b"
                    steps={[
                      "Frontend Developer",
                      1000,
                      "React JS Developer",
                      1000,
                      "Next JS Developer",
                      1000,
                      "Competitive Programmer",
                      1000,
                    ]}
                  />
                </span>
              </h3>
              <p>
                Welcome to my portfolio! I'm MD Mehedi Hasan, a passionate
                Frontend Developer dedicated to crafting beautiful and
                functional web experiences. Explore my work and discover how I
                turn ideas into interactive realities.
              </p>
              <div className="social-link">
                <a href="https://www.facebook.com/md.mehedi.hasan.018111" target="_blank">
                  <i class="fab fa-facebook-square"></i>
                </a>
                <a
                  href="https://www.linkedin.com/in/md-mehedi11/"
                  target="_blank"
                >
                  <i class="fab fa-linkedin"></i>
                </a>
                <a
                  href="https://github.com/MD-Mehedi-Hasan18111"
                  target="_blank"
                >
                  <i class="fab fa-github-square"></i>
                </a>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5}>
            <div className="banner-img">
              <img src={myImg} alt="" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Banner;
